import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Apple-style route transitions:
 * 1. Scrolls to top on route change (instant) — gives a clean entrance.
 * 2. Fades the new page in via the .route-fade-in class on the wrapper.
 *    Old page is unmounted instantly (Apple pattern: clean handoff, slow reveal).
 *
 * Mounted once at the top of <Routes>, around or as a sibling of <Routes>.
 */
export default function RouteTransition({ children }) {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top instantly - the fade-in below makes the transition feel polished
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div key={location.pathname} className="route-fade-in" data-testid="route-transition">
      {children}
    </div>
  );
}
